var _defs, _clipPath, _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagazineLogoIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.5 44.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M190.2 8.1h128.3v28.2H190.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.9 14.7c0-.5-.1-1-.3-1.4-.4-.6-1.1-1.1-1.9-1.1-1 0-1.9.6-2.4 1.5-.2.3-.2.6-.3.9l-.3 3h1.5c3.7.1 3.7-2.9 3.7-2.9m5.3 4.9c-.3-.1-.6-.2-1-.2h-14.3c-.5 0-1 .1-1.4.4-.7.4-1.2 1.2-1.3 2-.1 1 .4 1.9 1.3 2.3.3.1.6.2.9.2h4.7l-.4 4.7c0 .3 0 .7.1 1 .3.9 1.1 1.5 2.1 1.5s1.9-.6 2.3-1.4c.2-.3.3-.6.3-1l.4-4.7h4.7c.3 0 .7-.1 1-.2.9-.4 1.6-1.2 1.7-2.3.2-1-.3-1.9-1.1-2.3M226 30.9c-1 .6-2.2.9-3.7.9h-5.8l.6-7.2h6c1.6 0 2.8.1 3.5.7.7.7 1 1.5.9 2.6-.1 1.4-.6 2.4-1.5 3m-7.9-18.3h4.5c1.2 0 2.2.3 2.9.9.7.6 1 1.4.9 2.5-.1 1.3-.6 2.3-1.3 2.8-.8.6-1.7.9-2.8.9h-4.8l.6-7.1zm10.3 8.7c2-1.2 3.1-3.1 3.4-5.9.2-2.4-.5-4.2-2.1-5.5-1.6-1.2-3.5-1.9-5.8-1.9h-7.6c-.5 0-1 .2-1.4.4-.3.2-.5.4-.7.6-.4.4-.6 1-.7 1.5l-2 23c-.1.6.1 1.2.5 1.6.1.2.3.4.5.5.4.3.8.4 1.4.4h9.1c2.5 0 4.8-.7 6.7-1.9 2-1.3 3.1-3.3 3.3-5.8.2-1.9-.2-3.5-1.1-4.8-.9-.9-2-1.7-3.5-2.2m16.8 10.3c-1.1.6-2.2.9-3.3.9-.9 0-1.7-.2-2.3-.6-.5-.4-.8-.9-.7-1.5.2-1.8 3.6-2.5 6.6-2.7l-.3 3.9zm-1.3-14.9c-1.8 0-3.6.3-5.3 1-1.6.6-2.5 1.5-2.6 2.4 0 .5.1 1 .4 1.3.3.4.8.5 1.3.5.2 0 .7-.1 2.2-.7 1.1-.5 2.2-.7 3.3-.7s1.8.3 2.3.9c.4.5.5 1.3.4 2.4v.1c-3.4.3-5.8.7-7.5 1.4-2.6 1-4 2.7-4.2 5-.2 1.8.4 3.3 1.6 4.3 1.2 1 2.7 1.5 4.5 1.5 1.9 0 3.5-.3 4.9-1 .4.6 1 1 1.9 1 .7 0 1.3-.2 1.8-.7s.8-1 .9-1.7l.9-9.9c.2-2.2-.2-3.9-1.2-5.1-1.1-1.3-3-2-5.6-2m20.2 13.4c-1.2 1.3-2.8 1.9-4.9 1.9-.9 0-1.6 0-2.2-.1l.9-10.4c1-.4 2.1-.7 3.2-.7 1.4 0 2.5.5 3.3 1.4.9 1 1.2 2.4 1.1 4.1s-.6 2.9-1.4 3.8m-1.8-13.4c-1.4 0-2.7.2-4 .7l.6-6.9c0-.4 0-.7-.1-1-.3-.8-1.1-1.4-2.1-1.4-.8 0-1.6.4-2.1 1.1-.3.4-.5.8-.5 1.4l-2 22.7c-.1 1.5.5 2.4 2 2.7 1.1.2 2.6.3 4.4.3 4 0 7.1-1.1 9.2-3.3 1.6-1.7 2.6-3.8 2.8-6.4.3-2.9-.4-5.3-1.8-7.1-1.6-1.9-3.7-2.8-6.4-2.8m21.6 13.4c-1.2 1.3-2.8 1.9-4.9 1.9-.9 0-1.6 0-2.1-.1l.9-10.4c1-.4 2.1-.7 3.2-.7 1.4 0 2.5.5 3.3 1.4.9 1 1.2 2.4 1.1 4.1-.2 1.7-.6 2.9-1.5 3.8m-1.7-13.4c-1.4 0-2.7.2-4 .7l.6-6.9c0-.4 0-.7-.1-1-.3-.8-1.1-1.4-2.1-1.4-.8 0-1.6.4-2.1 1.1-.3.4-.5.8-.5 1.4l-2 22.7c-.1 1.5.5 2.4 2 2.7 1.1.2 2.6.3 4.4.3 3.9 0 7-1.1 9.2-3.3 1.6-1.7 2.6-3.8 2.8-6.4.3-2.9-.4-5.3-1.8-7.1-1.6-1.9-3.7-2.8-6.4-2.8m14.8 7.7c.2-.9.6-1.7 1.2-2.4.9-.9 2-1.3 3.5-1.3 1.3 0 2.3.4 3 1.2.5.7.8 1.5.8 2.4l-8.5.1zm5.1-7.7c-2.9 0-5.3.9-7.1 2.7-1.9 1.8-3 4.1-3.2 6.8-.3 2.9.4 5.3 2 7.1 1.6 1.9 4 2.9 7.2 2.9 2 0 3.9-.4 5.7-1.1 1.4-.6 2.2-1.4 2.3-2.4 0-.6-.1-1-.4-1.4-.4-.5-1-.8-1.9-.6-.2.1-.4.1-.5.2s-.3.1-.5.2l-.6.3c-1.1.5-2.3.8-3.5.8-1.7 0-3-.5-3.8-1.6-.6-.7-.9-1.6-1-2.6h10.8c.8 0 1.4-.3 1.9-.8s.8-1.1.8-1.9c.2-2.4-.4-4.5-1.8-6.1-1.6-1.6-3.7-2.5-6.4-2.5m16.4-6.2c0-.5-.1-1-.3-1.4-.4-.6-1.1-1.1-1.9-1.1-1 0-1.9.6-2.4 1.5-.2.3-.2.6-.3.9l-2 23.4c0 .3 0 .7.1.9.3.9 1.1 1.5 2.1 1.5s1.9-.6 2.3-1.4c.2-.3.3-.6.3-1l2.1-23.3z",
    clipPath: "url(#r)",
    fill: "#ff790f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 32.3v4H0V16.7h4.6v15.6h9.1zm15.2-.1H21l-1.4 4.1h-4.9L22 16.7h6l7.3 19.6h-5l-1.4-4.1zm-1.2-3.5L25 20.6l-2.7 8.1h5.4zm21.4.7h-2.3v6.9h-4.6V16.7H51c4.3 0 7.3 2.8 7.3 6.4 0 2.8-1.8 5.1-4.7 5.9l5.4 7.3h-5.7l-4.2-6.9zm-2.3-3.5h3.9c1.9 0 3.2-1.3 3.2-2.7 0-1.4-1.3-2.7-3.2-2.7h-3.9v5.4zm18.7-9.2v19.6h-4.6V16.7h4.6zm21 0l-6.7 19.6h-6l-6.7-19.6h5.2l4.5 15 4.5-15h5.2zm6.4 0v19.6h-4.6V16.7h4.6zM95.4 35v-5c2.2 1.6 5 2.9 7.2 2.9 1.5 0 2.5-.8 2.5-2 0-3.8-9.7-1.9-9.7-8.6 0-3.6 3.1-5.8 7.7-5.8 1.8 0 4.3.3 6.3.9v4.8c-2.2-1.2-4.5-2-6.2-2s-2.6.8-2.6 1.9c0 3.5 9.7 1.3 9.7 8.3 0 3.5-2.6 6.3-7.3 6.3-1.8-.1-4.9-.5-7.6-1.7zm32.9-14.3h-6.1v15.6h-4.7V20.7h-6v-4h16.9l-.1 4zm13 11.5h-7.9l-1.4 4.1h-5l7.3-19.6h6l7.3 19.6h-5l-1.3-4.1zm-1.2-3.5l-2.8-8.1-2.7 8.1h5.5zm32.9-2.2c0 5.6-4.5 9.8-10.4 9.8h-8.1V16.7h8.1c5.9 0 10.4 4.2 10.4 9.8zm-4.6 0c0-3.3-2.3-5.8-5.7-5.8h-3.6v11.5h3.6c3.4.1 5.7-2.4 5.7-5.7zm11.6-9.8v19.6h-4.6V16.7h4.6z",
    fill: "#284b7c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineLogoIt);
export default __webpack_public_path__ + "static/media/magazine-logo-it.2e9f8c682673f453d754731f78684bde.svg";
export { ForwardRef as ReactComponent };